module.exports = __webpack_public_path__ + "img/grid_select.788a7c0a.svg";